import { Button, Col, Form, Input, Row } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { sendPasswordResetEmail } from "@firebase/auth";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-hot-toast";

const Reset = () => {
  const [user, loading] = useAuthState(auth);
  const [isLoading, setIsLoading] = useState(true);
  const [isWait, setIsWait] = useState(false);

  const navigate = useNavigate();

  const onFinish = async (values) => {
    console.log("Success:", values);
    setIsWait(true);
    try {
      await sendPasswordResetEmail(auth, values.email);
      toast.success(
        "Password reset link has been sent. Please check your email."
      );
      navigate("/login");
      setIsWait(false);
    } catch (err) {
      toast.error(err.message);
      setIsWait(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    setIsWait(false);
    toast.error("Please enter a valid email address.");
  };

  useEffect(() => {
    if (!loading) {
      setIsLoading(false);
    }
    if (user) {
      navigate("/");
      setIsLoading(false);
    }
  }, [user, loading]);
  return (
    <div>
      {isLoading ? (
        <PropagateLoader color="#006eb7" size={5} className="loadingSpinner" />
      ) : (
        <Row>
          <Col xs={24} md={10} lg={10}>
            <div className="leftSide">
              <h1 className="companyTitle">SayEagle</h1>
              <h3 className="userLoginType">Property Manager</h3>
            </div>
          </Col>
          <Col xs={24} md={14} lg={14}>
            <div className="rightSide">
              <h3
                className="titlePage"
                style={{ fontSize: "calc(10px + 2vmin)" }}
              >
                Forgot password
              </h3>

              <Form
                name="basic"
                initialValues={{
                  remember: true,
                  totalUnits: {
                    number: 0,
                  },
                }}
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                style={{
                  maxWidth: 500,
                  width: "100%",
                }}
              >
                <Form.Item
                  label="Email Address"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Email Address!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%" }}
                    loading={isWait}
                  >
                    {isWait ? "please wait..." : "Send Reset Password Email"}
                  </Button>
                </Form.Item>
              </Form>
              <span>
                Already have an account? <Link to="/login">Login</Link> now.
              </span>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default Reset;
